export default {
  orders: {
    common: {
      continueShopping: 'Continuar a comprar',
    },
    status: {
      pending: 'Pendente',
      shipped: 'Enviado',
      delivered: 'Entregue',
      inDistribution: 'Em distribuição',
      cancelled: 'Cancelada',
    },
    card: {
      viewInfo: 'Ver informações',
      productImageAlt: 'Produto {{number}}',
    },
    list: {
      title: 'Encomendas',
      viewList: 'Vista em lista',
      viewTable: 'Vista em tabela',
      tabs: {
        all: 'Todas',
        pending: 'Pendentes',
        completed: 'Concluídas',
      },
      emptyTitle: 'Não há resultados',
      emptyDescription: 'Ainda não tem nenhuma encomenda. Vamos mudar isso :)',
      tableHeaders: {
        order: 'Encomenda',
        date: 'Data',
        status: 'Estado',
        items: 'Itens',
        total: 'Total',
        actions: 'Ações',
      },
      itemCount: '{{count}} itens',
      viewDetails: 'Ver detalhes',
    },
    details: {
      loadError: 'Ocorreu um erro ao carregar os detalhes da encomenda.',
      addedToFavorites: 'Produto adicionado aos favoritos',
      removedFromFavorites: 'Produto removido dos favoritos',
      orderNumber: 'No. {{code}}',
      orderDateLabel: 'Data da encomenda',
      orderStatusLabel: 'Estado do pedido',
      shippingMethodLabel: 'Método de envio',
      paymentStatusLabel: 'Estado do pagamento',
      paymentStatus: {
        cancelled: 'Cancelado',
        confirmed: 'Confirmado',
        pending: 'Pendente',
      },
      confirmationSentTo: 'Enviamos os dados de confirmação do pedido para {{email}}.',
      yourEmail: 'o seu email',
      productsHeading: 'Produtos',
      quantity: 'Quantidade: {{count}}',
      removeFromFavorites: 'Remover dos favoritos',
      addToFavorites: 'Adicionar aos favoritos',
      shippingStatusHeading: 'Estado do envio',
      trackingNumberLabel: 'Número de Localização:',
      copied: 'Copiado',
      copy: 'Copiar',
      totalPaid: 'Total Pago',
    },
    confirmation: {
      loading: 'A carregar encomenda...',
      notFound: 'Não foi possível encontrar esta encomenda.',
      retry: 'Tentar novamente',
      thankYou: 'Obrigado pela sua encomenda!',
      orderConfirmedPrefix: 'A sua encomenda',
      orderConfirmedSuffix: 'foi confirmada. Enviámos os detalhes para o seu email.',
      summaryHeading: 'Resumo da encomenda',
      qty: 'Qtd: {{count}}',
      subtotal: 'Subtotal',
      shipping: 'Envio',
      total: 'Total',
      shippingAddressHeading: 'Endereço de envio',
      paymentHeading: 'Pagamento',
      thanksForShopping: 'Obrigado por comprar na {{storeName}}.',
    },
  },
  budgets: {
    common: {
      order: 'Encomendar',
      addedToCart: 'Orçamento adicionado ao carrinho.',
      addToCartError: 'Erro ao adicionar ao carrinho.',
      codeLabel: 'Código: {{code}}',
    },
    status: {
      pending: 'Pendente',
      accepted: 'Aceite',
      rejected: 'Rejeitado',
      changesRequested: 'Alterações pedidas',
    },
    card: {
      itemCount: '{{count}} itens',
      pending: 'Pendente',
      completed: 'Orçamento Concluído',
      toOrder: 'Por encomendar',
      pendingValue: 'Valor Pendente',
      productAlt: 'Produto {{index}}',
      viewInfo: 'Ver informações',
    },
    details: {
      back: 'Voltar',
      loadError: 'Ocorreu um erro ao carregar o orçamento.',
      messageSent: 'Mensagem enviada com sucesso!',
      sendMessageError: 'Erro ao enviar mensagem.',
      productsHeading: 'Produtos',
      skuLabel: 'SKU: {{sku}}',
      unitPriceLabel: 'Preço Unitário',
      withoutVat: 'S/ IVA:',
      quantityLabel: 'Quantidade',
      discountLabel: 'Desconto',
      totalLabel: 'Total',
      subtotalLabel: 'Subtotal',
      shippingLabel: 'Envio',
      discountsLabel: 'Descontos',
      budgetTotalLabel: 'Total do Orçamento',
      messagesHeading: 'Mensagens',
      noMessages: 'Sem mensagens neste orçamento.',
      newMessageLabel: 'Nova Mensagem',
      messagePlaceholder: 'Adicionar nota ou mensagem...',
      sendMessage: 'Enviar Mensagem',
    },
    list: {
      delete: 'Eliminar orçamento',
      loadError: 'Ocorreu um erro ao carregar os orçamentos.',
      confirmDelete: 'Tem a certeza que deseja eliminar este orçamento?',
      deleteSuccess: 'Orçamento eliminado com sucesso.',
      deleteError: 'Erro ao eliminar orçamento.',
      title: 'Orçamentos',
      empty: 'Ainda não tem orçamentos guardados.',
      productCount_one: '{{count}} produto',
      productCount_other: '{{count}} produtos',
    },
    order: {
      cannotOrder: 'Este orçamento não pode ser encomendado.',
      addItemsError: 'Erro ao adicionar produtos ao carrinho.',
      prepareCartError: 'Erro ao preparar o carrinho.',
      applyCouponError: 'Erro ao aplicar condições do orçamento.',
    },
  },
  kits: {
    common: {
      adding: 'A adicionar...',
    },
    addProductCard: {
      label: 'Adicionar Produto',
    },
    dialog: {
      close: 'Fechar',
      closeDialog: 'Fechar diálogo',
      title: 'Adicionar produto ao kit',
      searchPlaceholder: 'Pesquisar produtos...',
      searchPrompt: 'Escreva para pesquisar produtos.',
      noResults: 'Nenhum produto encontrado para "{{query}}"',
      quantityLabel: 'Quantidade',
      add: 'Adicionar',
      addSuccess: 'Produto adicionado ao kit.',
      addError: 'Não foi possível adicionar o produto. Tente novamente.',
    },
    details: {
      breadcrumbHome: 'Início',
      breadcrumbKits: 'Kits',
      breadcrumbNewKit: 'Novo Kit',
      unavailable: 'Este kit não está disponível no momento',
      namePlaceholder: 'Nome do kit',
      descriptionPlaceholder: 'Descrição do kit',
      totalLabel: 'Total',
      creating: 'A criar...',
      saving: 'A guardar...',
      createButton: 'Criar Kit',
      saveButton: 'Guardar',
      cancel: 'Cancelar',
      edit: 'Editar',
      addToCart: 'Adicionar ao carrinho',
      addToCartSuccess: 'Kit adicionado ao carrinho com sucesso!',
      addToCartError: 'Erro ao adicionar kit ao carrinho.',
      nameRequired: 'O nome do kit é obrigatório.',
      invalidName: 'O nome do kit deve conter caracteres válidos.',
      createSuccess: 'Kit criado com sucesso.',
      createError: 'Erro ao criar o kit.',
      updateSuccess: 'Kit atualizado com sucesso.',
      updateError: 'Erro ao guardar alterações ao kit.',
      loading: 'Carregando detalhes do kit...',
      loadError: 'Erro ao carregar detalhes do kit',
      productsHeading: 'Produtos',
      createFirstPrompt: 'Crie o kit para poder adicionar produtos.',
    },
    item: {
      quantityLabel: 'Quantidade:',
      decreaseQuantity: 'Diminuir quantidade',
      increaseQuantity: 'Aumentar quantidade',
      quantityValue: 'Quantidade: {{count}}',
      packaged: 'Embalagem',
      remove: 'Remover',
    },
    list: {
      empty: 'Nenhum kit encontrado',
    },
    sort: {
      label: 'Ordenar por:',
      alphabetical: 'Alfabético',
      newest: 'Mais Recentes',
      oldest: 'Mais Antigos',
      moreItems: 'Mais Itens',
      lessItems: 'Menos Itens',
    },
    myKits: {
      title: 'Kits',
      loading: 'A carregar kits...',
      loadError: 'Erro ao carregar kits',
    },
    card: {
      itemCount_one: '{{count}} item',
      itemCount_other: '{{count}} itens',
      noItems: 'Nenhum item neste kit',
    },
  },
}
